<template>
  <v-navigation-drawer
    v-bind="$attrs"
    v-on="$listeners"
    app
    dark
    color="#C02B21"
  >
    <v-app-bar text class="toolbar" style="background-color: #711610">
      <v-spacer></v-spacer>
      <v-btn
        plain
        text
        :ripple="false"
        class="white--text px-0"
        @click="activeButtonProfile"
      >
        <v-toolbar-title class="text-button"
          >Módulo Administrador
          <transition name="fade">
            <v-icon v-if="activeIcon">mdi-wrench</v-icon>
          </transition>
        </v-toolbar-title>
      </v-btn>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-list nav>
      <v-list-item-group :value="getMenuIndex" @click="activeIcon = false">
        <div @click="activeIcon = false">
          <v-list-item
            v-for="(item, index) in items"
            :key="index"
            @click="changeToRoute(item)"
          >
            <v-list-item-action>
              <v-icon color="white">{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-title text class="font-weight-light">{{
              item.name
            }}</v-list-item-title>
          </v-list-item>
        </div>
      </v-list-item-group>
    </v-list>
    <template v-slot:append>
      <div class="pa-2">
        <v-btn block dark @click="logout('Admin')" class=""
          >Cerrar Sesión</v-btn
        >
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'UserHomeDrawer',

  props: {
    items: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      activeIcon: false
    }
  },

  methods: {
    activeButtonProfile() {
      this.activeIcon = true
      this.$router.push({ path: '/admin/perfil' })
    },

    changeToRoute(item) {
      this.$router.push({ path: item.path })
      if (item.path === '/admin/alumnos') {
        this.$emit('change-drawer')
      }
    },

    ...mapActions('auth', ['logout'])
  },

  computed: {
    getMenuIndex() {
      return this.$route.meta.menuIndex
    },

    getStaticProfile() {
      return require('@/assets/anonymous.png')
    },

    ...mapGetters('user', ['getUserInfo', 'getError', 'fetching'])
  },

  mounted() {
    if (this.$route.path.indexOf('perfil') !== -1) {
      this.activeIcon = true
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
